let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lrf77")).then(() => parcelRequire('bJDDe'));